import React from 'react';
import '../../styles/styles.scss';

/*Fonction Button*/

function Button({ text }) {
  return (
    <button>{text}</button>
  );
}

export default Button;